// @ts-nocheck
import addPanelDataConsts from '@/addPanelDataConsts';
import * as bookButtonWidgetConst from './bookButtonWidgetConst';
import editorActionsService from '../../common/editorActionsService';

export default function ({ editorAPI }) {
  const actionsService = editorActionsService({ editorAPI });
  const addPanelConsts = addPanelDataConsts;
  const bookButtonWidget = {
    id: bookButtonWidgetConst.BOOK_BUTTON_PRESET_KEY,
    structure: {
      layout: {
        x: 0,
        y: 0,
        width: 142,
        height: 42,
        scale: 1,
        rotationInDegrees: 0,
        fixedPosition: false,
      },
      data: {
        widgetId: bookButtonWidgetConst.BOOK_BUTTON_WIDGET_ID,
        variationId: undefined,
        installationType: 'open',
      },
      style: {
        type: 'TopLevelStyle',
        metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
        style: {
          properties: {},
          propertiesSource: {},
          groups: {},
        },
        componentClassName: 'wysiwyg.viewer.components.tpapps.TPAWidget',
        pageId: '',
        compId: '',
        styleType: 'custom',
        skin: 'wysiwyg.viewer.skins.TPAWidgetSkin',
      },
    },
    preset: {
      rect: { width: 201, height: 74, x: 10, y: 14 },
      label: '',
      tags: null,
    },
  };

  const bookButtonWidgetItems = [bookButtonWidget];

  return {
    id: 'wixBookingsBookButtonWidgets',
    type: addPanelConsts.SECTIONS_TYPES.PRESET,
    hide: false,
    title: bookButtonWidgetConst.BOOK_BUTTON_TITLE_KEY,
    subNavigationTitle: bookButtonWidgetConst.BOOK_BUTTON_TITLE_KEY,
    presetTitle: bookButtonWidgetConst.BOOK_BUTTON_TITLE_KEY,
    tooltipTitle: bookButtonWidgetConst.BOOK_BUTTON_TITLE_KEY,
    showSectionHeader: true,
    additionalBehaviours: {
      labelMode: addPanelConsts.LABEL_BEHAVIOUR.ALWAYS,
      infoIcon: addPanelConsts.INFO_ICON_BEHAVIOUR.NONE,
      hoverImageAction: addPanelConsts.HOVER_IMAGE_ACTIONS.NONE,
      scaleProportion: addPanelConsts.DEFAULT_SCALE_FOR_PRESET,
      iconEnabledForComps: [],
    },
    props: {
      image: bookButtonWidgetConst.BOOK_BUTTON_WIDGET_IMAGE_V1,
      imageHover: null,
      onDrop: actionsService.onRefWidgetDrop,
      onClick: actionsService.onRefWidgetClick,
      items: bookButtonWidgetItems,
      compTypes: ['wysiwyg.viewer.components.tpapps.TPAWidget'],
    },
  };
}
